import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import styles from './Dashboard.module.css';
import Button from '../../components/Button/Button';
import buttonStyles from '../../components/Button/Button.module.css';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';

const Dashboard = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');

    useEffect(() => {
    const name = localStorage.getItem('currentUser'); // Retrieved during login
    setUserName(name ? name : 'Guest'); // Fallback to 'Guest' if no name is found

    const token = localStorage.getItem('access_token');
    if (!token) {
      navigate('/login'); // Redirect to login if no token is found
    }
  }, [navigate]);

  const firstName = userName?.split(' ')?.[0] || 'Guest';
  return (
  <div style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
    {/* Blurred background image layer */}
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: "url('/images/iStock-907888472.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'blur(0px)',
        zIndex: 1, // Ensure it sits behind the content
      }}
    />
    
    {/* Foreground content (dashboard) */}
     <DashboardHeader></DashboardHeader>
    <div className={styles.dashboard} style={{ position: 'relative', zIndex: 2 }}>
        <h2 className={styles.hey}>Hey, {firstName}!</h2>
      <div className={styles.grid}>

        {/* Widget 1: Subscribe */}
        <div className={styles.widget}>
          <h3>Subscribe</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <Button className={buttonStyles.inverted} onClick={() => navigate('/checkout/price_1RbWNWQCTnInKdLDylSfW0sl')}>10x10 Unit - $75/mo</Button>
            <Button className={buttonStyles.inverted} onClick={() => navigate('/checkout/price_1RbWOfQCTnInKdLDmBo2p7xi')}>10x30 Unit - $150/mo</Button>
          </div>
        </div>

        {/* Widget 2: Help & Inquiries */}
        <div className={styles.widget}>
          <h3>Help & Inquiries</h3>
          <p>Email: kanina.1@icloud.com</p>
          <p>Phone: (940) 613-9620</p>
          <p>Location: Next door to Dollar General in Collinsville, TX</p>
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d831.1476961299605!2d-96.91272973045126!3d33.564006998334015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDMzUwLjQiTiA5NsKwNTQnNDMuNSJX!5e0!3m2!1sen!2sus!4v1756400466291!5m2!1sen!2sus" 
            width="400" 
            height="300" 
            styles="border:0;" 
            allowFullScreen 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
);

};

export default Dashboard;
